import PropTypes from 'prop-types';

export const ImageUploadPropTypes = {
  dataHook: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  imagesPool: PropTypes.array,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
};
